/**
 * Cross-component signal when Account Settings → Feature Toggles are saved.
 * Sidebar and feature hooks listen and re-fetch so UI updates without a full page reload.
 */

export const ACCOUNT_FEATURES_UPDATED_EVENT = "tv:account-features-updated";

/**
 * @param {string|number} accountId
 * @param {{ features?: Array<{ key?: string, enabled?: boolean }> }} [payload]
 */
export function notifyAccountFeaturesUpdated(accountId, payload = {}) {
  if (typeof window === "undefined" || accountId == null || accountId === "") {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(ACCOUNT_FEATURES_UPDATED_EVENT, {
      detail: {
        accountId: String(accountId),
        features: Array.isArray(payload.features) ? payload.features : undefined,
      },
    })
  );
}
